<template>
    <div class="row">
        <div class="col-md-6 mb-1">
            <label class="form-label">FMÜ [Fazla Mesai Ücreti]</label>
            <v-currency-input  input-class="text-right" :value="value.MESAI_UCRETI" v-on:update-value="currencyAmount => value.MESAI_UCRETI = currencyAmount"></v-currency-input>
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Yemek Yardımı</label>
            <v-currency-input  input-class="text-right" :value="value.YEMEK_UCRETI" v-on:update-value="currencyAmount => value.YEMEK_UCRETI = currencyAmount"></v-currency-input>
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Yol Yardımı</label>
            <v-currency-input  input-class="text-right" :value="value.YOL_UCRETI" v-on:update-value="currencyAmount => value.YOL_UCRETI = currencyAmount"></v-currency-input>
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Kart Tutarı</label>
            <v-currency-input input-class="text-right" v-model="value.TICKET" v-on:update-value="currencyAmount => value.TICKET = currencyAmount"></v-currency-input>
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Prim [Destek]</label>
            <v-currency-input  input-class="text-right" :value="value.DESTEK_PRIMI" v-on:update-value="currencyAmount => value.DESTEK_PRIMI = currencyAmount"></v-currency-input>
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Hamaliye Ücreti</label>
            <v-currency-input  input-class="text-right" :value="value.HAMMALIYE_BEDELI" v-on:update-value="currencyAmount => value.HAMMALIYE_BEDELI = currencyAmount"></v-currency-input>
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Bekleme</label>
            <v-currency-input  input-class="text-right" :value="value.YATMA" v-on:update-value="currencyAmount => value.YATMA = currencyAmount"></v-currency-input>
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Prim [Yakıt]</label>
            <v-currency-input  input-class="text-right" :value="value.MAZOT_PRIMI" v-on:update-value="currencyAmount => value.MAZOT_PRIMI = currencyAmount"></v-currency-input>
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Dengeleyici Ücret</label>
            <v-currency-input  input-class="text-right" :value="value.SIFIRLAMA" v-on:update-value="currencyAmount => value.SIFIRLAMA = currencyAmount"></v-currency-input>
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">FMÜ [Bayram] [Fazla Mesai Ücreti Bayram]</label>
            <v-currency-input  input-class="text-right" :value="value.BAYRAM_MESAISI" v-on:update-value="currencyAmount => value.BAYRAM_MESAISI = currencyAmount"></v-currency-input>
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Prim (KM-Ton)</label>
            <v-currency-input  input-class="text-right" :value="value.PRIM" v-on:update-value="currencyAmount => value.PRIM = currencyAmount"></v-currency-input>
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Trafik Cezası [Banka 1]</label>
            <v-currency-input  input-class="text-right" :value="value.TRAFIK_CEZA" v-on:update-value="currencyAmount => value.TRAFIK_CEZA = currencyAmount"></v-currency-input>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">ODÖ [Olağandışı Ödemeler]</label>
            <v-currency-input  input-class="text-right" :value="value.DIGER" v-on:update-value="currencyAmount => value.DIGER = currencyAmount"></v-currency-input>
        </div>
        <div class="col-12">
            <label class="form-label">Açıklama</label>
            <textarea class="form-control resize-none" rows="2" v-model="value.DIGERACIKLAMA"></textarea>
        </div>
    </div>
</template>

<script>
import VCurrencyInput from '@/components/VCurrencyInput.vue'
export default {
    props:{
        value:Object
    },
    components:{
        VCurrencyInput
    }
}
</script>